var ___EXPOSE_LOADER_IMPORT___ = require("-!../../../../node_modules/i18next-loader/index.js??ruleSet[1].rules[14]!./modernizr.js");
var ___EXPOSE_LOADER_GET_GLOBAL_THIS___ = require("../../../../node_modules/expose-loader/dist/runtime/getGlobalThis.js");
var ___EXPOSE_LOADER_GLOBAL_THIS___ = ___EXPOSE_LOADER_GET_GLOBAL_THIS___;
if (typeof ___EXPOSE_LOADER_GLOBAL_THIS___["Modernizr"] === 'undefined') ___EXPOSE_LOADER_GLOBAL_THIS___["Modernizr"] = ___EXPOSE_LOADER_IMPORT___;
module.exports = ___EXPOSE_LOADER_IMPORT___;
